import { render, staticRenderFns } from "./_GearCardContent.vue?vue&type=template&id=030fea5d&scoped=true&"
import script from "./_GearCardContent.vue?vue&type=script&lang=ts&"
export * from "./_GearCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./_GearCardContent.vue?vue&type=style&index=0&id=030fea5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030fea5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
